var loop = new Loop();

function LocationGrid(el) {
    this.region = el.querySelectorAll('.block__region');

    this.init = function () {
        var base = 4;

        if (this.region.length > 0) {
            this.region.forEach(function (element) {
                element.style.setProperty('--location-row-end', (10 + Math.ceil(element.clientHeight / base)));
                element.classList.add('block__region--masonry');
            });
        }

        el.classList.add('block__regions--masonry');
    }
}
